export default __webpack_public_path__ + "static/media/reject.6ea169b6.svg";